import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumbs } from "../../assets/svg";

const Breadcrumb = ({
  breadCrumbParent,
  breadCrumbParent2,
  breadCrumbParent3,
  breadCrumbActive,
  breadCrumbTitleKey,
  breadCrumbParentKey2,
  breadCrumbParentKey3,
  breadCrumbActiveKey,
  classes,
}) => {
  const baseLinkClass = "lg:text-base text-sm";
  const fadedLinkClass = "opacity-70";
  const breadcrumbItemClass = "flex items-center justify-center gap-x-2";

  return (
    <div>
      <ul
        className={`flex items-center overflow-x-auto gap-x-2 whitespace-nowrap font-quiche ${classes}`}
      >
        {breadCrumbParent && (
          <li>
            <Link
              to={breadCrumbTitleKey || "#"}
              className={`${baseLinkClass} ${fadedLinkClass}`}
            >
              {breadCrumbParent}
            </Link>
          </li>
        )}

        {breadCrumbParent2 && (
          <li className={breadcrumbItemClass}>
            <Breadcrumbs size="16" />
            <Link
              to={breadCrumbParentKey2 || "#"}
              className={`${baseLinkClass} ${fadedLinkClass}`}
            >
              {breadCrumbParent2}
            </Link>
          </li>
        )}

        {breadCrumbParent3 && (
          <li className={breadcrumbItemClass}>
            <Breadcrumbs size="16" />
            <Link
              to={breadCrumbParentKey3 || "#"}
              className={`${baseLinkClass} ${fadedLinkClass}`}
            >
              {breadCrumbParent3}
            </Link>
          </li>
        )}

        {breadCrumbActive && (
          <li className={`${breadcrumbItemClass} pointer-events-none`}>
            <Breadcrumbs size="16" />
            <Link to={breadCrumbActiveKey || "#"} className={baseLinkClass}>
              {breadCrumbActive}
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Breadcrumb;
